import $ from 'jquery';
import axios from 'axios';

import { devConfig } from './Config';
import SessionHelper from './SessionHelper';
import Constants from './Constants';

export default class AjaxHelper {
	static invokeServerAPI(url, params, callback) {
		const id = $('#_id');
		if (id.val()) {
			params.id = id.val();
		}

		const URL = devConfig.APIURI + url;
		// console.log('URL::',URL);
		$.ajax({
			type: 'post',
			url: URL,
			dataType: 'json',
			cache: false,
			data: JSON.stringify(params),
			beforeSend(xhr) {
				xhr.setRequestHeader(Constants.SESSION_HASHCODE, SessionHelper.get(Constants.SESSION_HASHCODE));
			},
			contentType: 'application/json; charset=utf-8',
			success(data) {
				if (callback) callback(null, data);
			},
			error(jqXHR) {
				callback(new Error(jqXHR.responseText), null);
			}
		});
	}

	static async invokeServerAPIPromise(url, params) {
		const data = { ...params };

		return new Promise((resolve, reject) => {
			const headers = {};
			headers[Constants.SESSION_HASHCODE] = SessionHelper.get(Constants.SESSION_HASHCODE);
			axios({
				method: 'POST',
				url,
				data,
				headers,
			}).then((response) => {
				resolve(response.data);
			}).catch((err) => {
				reject(err);
			});
		});
	}

	static saveFileToServer(url, params, callback) {
		const URL = devConfig.APIURI + url;
		$.ajax({
			type: 'POST',
			url: URL,
			processData: false,
			cache: false,
			data: params,
			beforeSend(xhr) {
				xhr.setRequestHeader(Constants.SESSION_HASHCODE, SessionHelper.get(Constants.SESSION_HASHCODE));
			},
			timeout: 600000,
			contentType: false,
			mimeType: 'multipart/form-data',
			success(data) {
				if (callback) callback(null, data);
			},
			error(jqXHR) {
				callback(new Error(jqXHR.responseText), null);
			}
		});
	}

	static async postAPIWithCorsMode(url, params) {
		const data = { ...params };

		return new Promise((resolve, reject) => {
			fetch(url, {
				mode: 'cors',
				credentials: 'include',
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify(data)
			})
				.then((response) => resolve(response.data))
				.catch((err) => {
					reject(err);
				});
		});
	}
}
